import React from 'react';
import { CommonButton } from '~/common/components/CommonButton';
import { Spinner } from '~/common/components/Spinner';
import { TRIAL_TYPES } from '~/common/consts';
import { ModalContentType, SitecoreTrialContentType } from '~/common/types';
import styles from './Trial.module.css';

type TrialButtonSwitchType = {
  formSubmitting: boolean;
  data: SitecoreTrialContentType;
  modalContent?: ModalContentType;
  handleCallback?: (step: number) => void;
  goToNextStep?: () => void;
  handleBackClick?: () => void;
  step: number;
  is2Step: boolean;
  hero?: true;
};

type ViewType = 'MODAL_STEP_1' | 'MODAL_STEP_2' | 'MODAL_SINGLE' | 'TWO_STEP_1' | 'TWO_STEP_2' | 'SINGLE';

export const TrialButtonSwitch = ({
  formSubmitting,
  data,
  modalContent,
  handleCallback,
  goToNextStep,
  handleBackClick,
  step,
  is2Step,
  hero,
}: TrialButtonSwitchType) => {
  const modalType = window.TrialForm?.modalType;
  const { trialType } = window.LPFormData;

  const view: ViewType = (() => {
    if (modalType && modalContent) {
      if (trialType === TRIAL_TYPES.BUSINESS) {
        return step === 1 ? 'MODAL_STEP_1' : 'MODAL_STEP_2';
      } else {
        return 'MODAL_SINGLE';
      }
    }
    if (is2Step) {
      return step === 1 ? 'TWO_STEP_1' : 'TWO_STEP_2';
    }
    return 'SINGLE';
  })();

  const renderSpinner = (content: React.ReactNode) =>
    formSubmitting ? <Spinner colorBottom="#751a17" colorTop="#fff" /> : content;

  return (
    <>
      {(() => {
        switch (view) {
          case 'MODAL_STEP_1':
            // modal + step === 1
            return (
              <div className={styles.buttonHolder}>
                <CommonButton type="button" link onClick={() => handleCallback(0)}>
                  {modalContent.backButton}
                </CommonButton>

                <CommonButton type="button" id="EMAIL_SUBMIT" disabled={formSubmitting} onClick={goToNextStep}>
                  {renderSpinner(modalContent.sendButton)}
                </CommonButton>
              </div>
            );

          case 'MODAL_STEP_2':
            // modal + step !== 1
            return (
              <div className={styles.buttonHolder}>
                <CommonButton type="button" link onClick={handleBackClick}>
                  {modalContent.backButton}
                </CommonButton>

                <CommonButton id="FORM_SUBMIT" type="submit" disabled={formSubmitting}>
                  {renderSpinner(data.sendButton2)}
                </CommonButton>
              </div>
            );

          case 'MODAL_SINGLE':
            // modal + step !== 1
            return (
              <div className={styles.buttonHolder}>
                <CommonButton type="button" link onClick={() => handleCallback(0)}>
                  {modalContent.backButton}
                </CommonButton>

                <CommonButton id="FORM_SUBMIT" type="submit" disabled={formSubmitting}>
                  {renderSpinner(data.sendButton)}
                </CommonButton>
              </div>
            );

          case 'TWO_STEP_1':
            // 2-step (non-modal) + step === 1
            return (
              <CommonButton
                type="button"
                id="EMAIL_SUBMIT"
                disabled={formSubmitting}
                onClick={goToNextStep}
                style={hero && { padding: '6px 40px', minHeight: '40px' }}
              >
                {renderSpinner(data.sendButton)}
              </CommonButton>
            );

          case 'TWO_STEP_2':
            // 2-step (non-modal) + step !== 1
            return (
              <div className={styles.buttonHolder}>
                <CommonButton type="button" link onClick={handleBackClick}>
                  {data.backButton}
                </CommonButton>

                <CommonButton id="FORM_SUBMIT" type="submit" disabled={formSubmitting}>
                  {renderSpinner(data.sendButton2)}
                </CommonButton>
              </div>
            );

          case 'SINGLE':
          default:
            // 1-step form
            return (
              <CommonButton id="FORM_SUBMIT" type="submit" disabled={formSubmitting}>
                {renderSpinner(data.sendButton)}
              </CommonButton>
            );
        }
      })()}
    </>
  );
};
